module.exports = __webpack_public_path__ + "static/assets/aae8b2a6389a72cabfad4c1c35ef03d9.png";